import React, { Fragment } from 'react'
import { Pill } from '@myxplor/ui'
import RecordHeading from '../../../ui/record-heading'
import RecordDisplayList from '../../../ui/record-display-list'
import ActiveFilter from '../../../ui/active-filter'
import RecordMessages from '../../../ui/record-messages'
import { hasAvailableAction } from '../../../ui/gov-actions'
import ParentalAgreementLink from './parental-agreement-link'

const parentName = ({ parent_first_name, parent_last_name }) =>
  [parent_first_name, parent_last_name].filter(val => val).join(' ')

const EnrolmentView = ({ record, children }) => (
  <Fragment>
    <RecordHeading record={record} />
    <RecordMessages messages={record.messages} />

    <ActiveFilter records={record.enrolments} filterOn={record => record.active}>
      <RecordDisplayList
        name="Xplor Profile"
        recordBadgesComponent={CareProfileBadges}
        actionButtonsComponent={
          hasAvailableAction(record, 'can_view_parent_approval') ? ParentalAgreementLink : null
        }
        level1={[
          {
            key: 'care_service_id',
            label: 'Service ID',
          },
          {
            label: 'Parent Name',
            fn: parentName,
          },
          {
            key: 'parent_crn',
            label: 'Parent CRN',
          },
          {
            key: 'parent_dob',
            label: 'Parent DOB',
          },
        ]}
        level2={[
          {
            key: 'parent_id',
            label: 'Parent ID',
          },
          {
            key: 'start',
            label: 'Start date',
          },
          {
            key: 'end',
            label: 'End date',
          },
        ]}
      />
    </ActiveFilter>
    {children}
  </Fragment>
)

const CareProfileBadges = ({ record }) => (
  <Fragment>
    <h4>ID: {record.care_id}&nbsp;</h4>
    <ul>
      <li> <Pill warning={!record.active}>{record.active ? 'Active' : 'Inactive'}</Pill></li>
    </ul>
  </Fragment>
)

export default EnrolmentView



// WEBPACK FOOTER //
// ./src/care-enrolments/details/views/index.jsx